// import { f } from '../../../../../production/assets/js/polyfills.bundle';

// CONSTANTS are all caps.
const NS = 'SiteHeaderV2';
const CLS = 'siteHeaderV2';
const BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class SiteHeaderV2 {
	constructor($el) {
		// $el is the blk node return by the loadSiteHeader function
		this.$el = $el;

		this.mobileMenuBtn = this.$el.querySelector(`${BLK}navBarToggler`);
		this.navItemsList = this.$el.querySelectorAll(`${BLK}siteNavItem`);
		this.searchButton = this.$el.querySelector(`${BLK}search`);
		this.searchBar = this.$el.querySelector(`.siteHeaderSearchBarV2`);
		this.searchBarInput = this.searchBar.querySelector(`.siteHeaderSearchBarV2-searchInput`);
		this.topBar = this.$el.querySelector(`.siteHeaderTopBarV2-menu`);

		this.oldEl;
		this.oldIcon;

		this.disableClick = false;
	}

	init() {
		$('#siteHeaderMegaMenuV2-desk').collapse({
			toggle: false,
		});

		// $('#siteHeaderMegaMenuV2-desk').on('shown.bs.collapse', function(event) {
		// 	if ($(this).is(event.target)) {

		// 	}
		// });

		// $('#siteHeaderMegaMenuV2-desk').on('hidden.bs.collapse', function(event) {
		// 	if ($(this).is(event.target)) {

		// 	}
		// });

		$('#siteHeaderMegaMenuV2-mobile').on('show.bs.collapse', function(event) {
			if ($(this).is(event.target)) {
				event.stopImmediatePropagation();
				event.stopPropagation();

				$('.siteHeaderV2').addClass('menu-open');
				$('#siteHeaderV2-overlay').removeClass('d-none');

				$('.icon-menu.mobile-menu-icon').addClass('icon-close');
				$('.icon-menu.mobile-menu-icon').removeClass('icon-menu');
			}
		});

		$('#siteHeaderMegaMenuV2-mobile').on('hidden.bs.collapse', function(event) {
			if ($(this).is(event.target)) {
				event.stopImmediatePropagation();
				event.stopPropagation();

				$('.siteHeaderV2').removeClass('menu-open');
			}
		});

		$('#siteHeaderMegaMenuV2-mobile').on('hide.bs.collapse', function(event) {
			if ($(this).is(event.target)) {
				event.stopImmediatePropagation();
				event.stopPropagation();

				$('.icon-close.mobile-menu-icon').addClass('icon-menu');
				$('.icon-close.mobile-menu-icon').removeClass('icon-close');
				$('#siteHeaderV2-overlay').addClass('d-none');
			}
		});

		let prevScrollpos = window.pageYOffset;

		/**
		 * scroll up: show top search bar and bottom wrapper
		 * scroll down: only show bottom wrapper component
		 */

		window.onscroll = function() {
			let ua = window.navigator.userAgent;

			let msie = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1 || ua.indexOf('Safari') > -1;


			// If Internet Explorer, return version number
			if (msie) {
				// alert(parseInt(ua.substring(msie + 5, ua.indexOf('.', msie))));
				// do nothing
			} else {
				// If another browser
				let currentScrollPos = window.pageYOffset;
				if (prevScrollpos > currentScrollPos) {
					console.log('up');
					$('.siteHeaderV2').removeClass('headroom--locked');
				} else {
					console.log('down');
					$('.siteHeaderV2').addClass('headroom--locked');
				}
				prevScrollpos = currentScrollPos;
			}
		};

		this.setSiteHeader();

		$(this.$el).on('siteHeaderV2.siteHeaderSearchBarV2.open', (_e) => {
			this.topBar.classList.remove('show');
			this.searchBar.classList.remove('out');

			$('.siteHeaderTopBarV2').addClass('searchbar-shown');
			// Timeout needed to stop weird transition when setting focus while the text box is sliding out
			setTimeout(() => this.searchBarInput.focus(), 500);
		});

		$(this.$el).on('siteHeaderV2.siteHeaderSearchBarV2.close', (_e) => {
			this.topBar.classList.add('show');
			this.searchBar.classList.add('out');

			$('.siteHeaderTopBarV2').removeClass('searchbar-shown');
		});

		this.searchButton.addEventListener('click', () => {
			$(this.$el).trigger('siteHeaderV2.siteHeaderSearchBarV2.open');
		});
	}

	setSiteHeader() {
		// desktop menu nav-item click
		this.initMenuDesk();
		this.initMenuMobile();

		// init overlay click event
		$(`${BLK}overlay`).on('click', () => {
			$('#siteHeaderV2-overlay').addClass('d-none');
			// this.desktopCollapse.hide();
			$('#siteHeaderMegaMenuV2-desk').collapse('hide');
			$('#siteHeaderMegaMenuV2-mobile').collapse('hide');
			$('.siteHeaderV2-btnIcon').removeClass('icon-close');
			$('.siteHeaderV2-btnIcon').addClass('icon-plus');

			if (this.oldItem) {
				this.setInactiveMenu(this.oldItem);
			}

			this.setInactiveMenuMob();
			this.mobileMenuBtn.attributes.active = false;
		});
	}

	initMenuMobile() {
		this.mobileMenuBtn.addEventListener('click', () => {
			if (this.mobileMenuBtn.attributes && this.mobileMenuBtn.attributes.active) {
				this.mobileMenuBtn.attributes.active = false;
			} else {
				this.mobileMenuBtn.attributes.active = true;
			}
		});
	}

	setInactiveMenuMob() {

	}

	initMenuDesk() {
		for (let i = this.navItemsList.length - 1; i >= 0; i--) {
			let item = this.navItemsList[i];
			item.addEventListener('click', (e) => {
				e.preventDefault();

				if (this.disableClick === true) {
					return false;
				}

				let $el = $(item);
				let $icon = $el.find('.siteHeaderV2-btnIcon');
				let index = $el.data('menu-index');

				if (typeof this.oldItem === 'undefined' || this.oldItem.data('menu-index') !== $el.data('menu-index')) {
					this.showMega(index);
					this.setActiveMenu(item);

					if (this.oldItem) {
						this.setInactiveMenu(this.oldItem);
					}
				} else {
					if (!this.isActive($el)) {
						this.showMega(index);
						this.setActiveMenu(item);
					} else {
						this.hideMega(index);
						this.setInactiveMenu(this.oldItem);
					}
				}

				this.oldItem = $el;
			});
		}
	}

	hideMega(index) {
		this.disableClick = true;

		console.log('collapse hide megamenu');
		// $('#siteHeaderMegaMenuV2-desk').removeClass('show');
		// this.desktopCollapse.hide();
		$('#siteHeaderMegaMenuV2-desk').collapse('hide');
		$('#siteHeaderMegaMenuV2-mobile').removeClass('show');
		setTimeout(() => {
			$(`#mega-menu-${index}`).removeClass('megamenu-visible z-1');
			$(`#mega-menu-${index}`).siblings().removeClass('megamenu-visible');

			this.disableClick = false;
		}, 1000);
		$(`#${CLS}-overlay`).addClass('d-none');
	}

	showMega(index) {
		this.disableClick = true;

		setTimeout(() => {
			this.disableClick = false;
		}, 1000);
		// $('#siteHeaderMegaMenuV2-desk').addClass('show');
		let menuPromise;
		if ($('#siteHeaderMegaMenuV2-desk').hasClass('show')) {
			$('#siteHeaderMegaMenuV2-desk').collapse('hide');

			menuPromise = new Promise((resolve, reject) => {
				setTimeout(() => {
					resolve();
				}, 750);
			});
		}


		if (menuPromise !== undefined && menuPromise !== null) {
			menuPromise.then(() => {
				console.log('collapse then');
				$('#siteHeaderMegaMenuV2-mobile').addClass('show');

				$(`#mega-menu-${index}`).addClass('megamenu-visible z-1');
				$(`#mega-menu-${index}`).siblings().removeClass('megamenu-visible');
				$(`#${CLS}-overlay`).removeClass('d-none');

				setTimeout(() => {
					$('#siteHeaderMegaMenuV2-desk').collapse('show');
				}, 10);
			});
		} else {
			$('#siteHeaderMegaMenuV2-mobile').addClass('show');

			$(`#mega-menu-${index}`).addClass('megamenu-visible z-1');
			$(`#mega-menu-${index}`).siblings().removeClass('megamenu-visible');
			$(`#${CLS}-overlay`).removeClass('d-none');

			setTimeout(() => {
				$('#siteHeaderMegaMenuV2-desk').collapse('show');
			}, 10);
		}
	}

	setActiveMenu(item) {
		let $el = $(item);
		let $icon = $el.find('.siteHeaderV2-btnIcon');
		let bg = $el.data('menu-bg');
		$el.addClass('is-siteNavItem-open');

		// $el.removeClass('text-very-dark-grey');
		// $el.addClass('text-white');
		// $el.addClass(bg);

		// $icon.removeClass('text-salmon');
		// $icon.addClass('text-white');

		$icon.removeClass('icon-plus');
		$icon.addClass('icon-close');

		$el.data('active', 'active');

		console.log($el.data('active'));
	}

	setInactiveMenu(item) {
		let $el = $(item);
		let $icon = $el.find('.siteHeaderV2-btnIcon');
		let bg = $el.data('menu-bg');
		$el.removeClass('is-siteNavItem-open');

		// $el.addClass('text-very-dark-grey');
		// $el.removeClass('text-white');
		// $el.removeClass(bg);

		// $icon.addClass('text-salmon');
		// $icon.removeClass('text-white');

		$icon.addClass('icon-plus');
		$icon.removeClass('icon-close');

		$el.data('active', '');
	}

	isActive($el) {
		return ($el && $el.data('active') === 'active');
	}
	// Add more functions like on above here
}
